import React from 'react';
import { WarningCircleIcon } from '@phosphor-icons/react';
import { Button } from '@origo/origo-ui';
import styles from './AccessDeniedScreen.module.css';

export interface AccessDeniedScreenProps {
    title: string;
    message: string;
    actionLabel: string;
    onAction: () => void;
}

/**
 * Full-skjerm tilgangs- eller innstillings-feil vist når brukeren er
 * innlogget i ArcGIS Online, men appen ikke kan fortsette (manglende
 * gruppemedlemskap, avvist settings-item, eller en forbigående feil ved
 * lasting av innstillinger).
 */
export const AccessDeniedScreen: React.FC<AccessDeniedScreenProps> = ({ title, message, actionLabel, onAction }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.card} role="alert">
                <div className={styles.cardBody}>
                    <WarningCircleIcon size={32} weight="duotone" className={styles.icon} aria-hidden="true" />
                    <div className={styles.text}>
                        <strong className={styles.title}>{title}</strong>
                        <p className={styles.message}>{message}</p>
                    </div>
                </div>
                <div className={styles.cardFooter}>
                    <Button variant="secondary" onClick={onAction}>
                        {actionLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
};
